<template>

  <div id="autor">

    <vue-headful
          :title="title"
          description="Textos y antolog&iacute;as de autores latinoamericanos"
      />

    <header class="secondary-header">
      <div class="cont">
        <h1>
          <router-link :to="'/'">
            <span class="verde-span">Pensamientos</span> latinoamericanos
          </router-link>
        </h1>

        <transition name="fade" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
          <p v-if="fullName">Autores / {{ fullName }}</p>
        </transition>
      </div>
    </header>

    <!-- Loading -->
    <div class="loading" v-if="loading">
      <div class="loader"></div>
    </div>


    <transition name="fade" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" mode="out-in">

      <main class="cont" v-if="obras">
        <header class="autor-header verde">
        <div :style="autorImg(img)" class="autor-img"></div>
            <h2>{{ nombre }} <span class="accent">{{ apellido }}</span></h2>
        </header>

        <section class="main-content">

          <div class="libro-item verde" v-for="obra in obras">
            <router-link :to="{ name: 'obra', params: {autor: $route.params.id, obra: obra.id } }">

              <div v-if="obra.portada">

                <img :src="imgRoute(obra.portada)" :alt="obra.titulo">
                <h3>{{ obra.titulo }}</h3>
                <p class="light">{{ obra.publicado }}</p>

              </div>

              <div v-else class="portada-pdf">
                <h3>{{ obra.titulo }}</h3>
                <p class="light">{{ obra.publicado }}</p>
              </div>



            </router-link>
          </div>

        </section>


      </main>

    </transition>

  </div>
</template>

<script>
export default {
  name: 'Autor',

  props: ['autorId', 'obraId'],

  data (){
    return {
      autor: null,
      apellido: null,
      img: null,
      carpeta: false,
      error: null,
      loading: false,
      nombre: null,
      obras: false,
      title: '',
    }
  },

  created (){
    this.fetchData();

    title = fullName + ' - Pensamientos';
  },

  computed: {
    fullName: function (){
      return this.nombre + ' ' + this.apellido;
    }
  },

  watch: {
    '$route' : 'fetchData'
  },

  methods: {
    fetchData (){
      this.error = this.obras = null;
      this.loading = true;

      this.$http.get('/api/obras.php', { params: {id: this.$route.params.id }}).then( function(response) {
      // this.$http.get('http://temp1.unla.edu.ar/penslat-build/api/obras.php', { params: {id: this.$route.params.id }}).then( function(response) {

          this.loading = false;

          this.obras = response.data;

          this.autor = this.obras[0];

          this.nombre = this.autor.nombre;

          this.apellido = this.autor.apellido;

          this.img = this.autor.img;

      }, function(response) {

          console.log('Error: no se recibieron las obras');

      });

      /* TEST DATA
      --------------------------------------*/
      // this.loading = false;

      // this.obras = [{"id":"1","titulo":"El porvenir de Am\u00e9rica Latina","publicado":"1910","portada":"el-porvenir.jpg","nombre":"Manuel","apellido":"Ugarte"},{"id":"2","titulo":"Mi campa\u00f1a hispanoamericana","publicado":"1922","portada":"mi-campana.jpg","nombre":"Manuel","apellido":"Ugarte"},{"id":"3","titulo":"El destino de un continente","publicado":"1923","portada":"el-destino.jpg","nombre":"Manuel","apellido":"Ugarte"},{"id":"4","titulo":"La Patria Grande","publicado":"1924","portada":"la-patria-grande.jpg","nombre":"Manuel","apellido":"Ugarte"},{"id":"5","titulo":"La reconstrucci\u00f3n de Hispanoam\u00e9rica","publicado":"1961","portada":"la-reconstruccion.jpg","nombre":"Manuel","apellido":"Ugarte"}];

      // this.nombre = 'Manuel';
      // this.apellido = 'Ugarte';
      // this.img = 'ugarte.png';

      /* END TEST DATA -----------------------*/

    },

    imgRoute (portada){
      this.carpeta = this.apellido.toLowerCase().replace(/\ /g, '-');
      return '/static/img/obras/' +  portada;
      // return 'static/img/obras/' +  portada;
    },

    autorImg (img){
      return 'background-image: url("/static/img/autores/'+ img +'");';
      // return 'background-image: url("static/img/autores/'+ img +'");';
    }


  }
}
</script>


// WEBPACK FOOTER //
// src/components/Autor.vue